import { stringify } from "querystring"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import type { UseGetTransferApplicationsParams } from "../types"

/**
 * 立替送金申請関連のSWRキー生成関数
 */

/** ベースURL */
const TRANSFER_APPLICATIONS_BASE_URL = `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/transfer_applications`

/**
 * 立替送金申請一覧取得用のSWRキーを生成
 * @param params - クエリパラメータ
 * @returns SWRキーの配列
 */
export const createTransferApplicationsKey = (params: UseGetTransferApplicationsParams = {}) => {
  const query: { page: number; transferApplicationId?: number } = {
    page: params.page || 1,
  }

  if (params.transferApplicationId) {
    query.transferApplicationId = params.transferApplicationId
  }

  const url = `${TRANSFER_APPLICATIONS_BASE_URL}?${stringify(query)}`

  // SWRキーを配列形式で返す（依存関係を明確にするため）
  return [url, query] as const
}

/**
 * 立替送金申請一覧のベースURLを取得
 * @returns ベースURL
 */
export const getTransferApplicationsBaseUrl = () => TRANSFER_APPLICATIONS_BASE_URL

/**
 * 特定のページの立替送金申請一覧キーを生成
 * @param page - ページ番号
 * @returns SWRキー
 */
export const createTransferApplicationsPageKey = (page: number) => {
  return createTransferApplicationsKey({ page })
}

/**
 * 特定のIDの立替送金申請キーを生成
 * @param transferApplicationId - 立替送金申請ID
 * @param page - ページ番号（オプション）
 * @returns SWRキー
 */
export const createTransferApplicationsByIdKey = (transferApplicationId: number, page?: number) => {
  return createTransferApplicationsKey({ transferApplicationId, page })
}
